import {Component} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../services/auth.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {GoogleAnalyticsService} from "ngx-google-analytics";
import {TrackingHelperService} from "../../../services/tracking-helper.service";
import {ConfigService} from "../../../services/config.service";
import {ModalService} from "../../../services/modal.service";


@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent {

  loginForm!: UntypedFormGroup;
  loginSubmit!: boolean;
  fieldTextType!: boolean;

  isLoading:boolean = false;

  hasMinReg:boolean;


  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private gaService:GoogleAnalyticsService,
    private trackingService: TrackingHelperService,
    private configs: ConfigService,
    private modalService: ModalService
  ) {
    this.hasMinReg = this.configs.hasMinimalRegistration;

    this.loginForm = this.formBuilder.group({
      login: ['', [Validators.required]],
      password: ['', [Validators.required]],
      mode: ['real', [Validators.required]]
    });
  }

  submitLoginForm() {
    this.loginSubmit = true;
    if (this.logForm['login'].valid && this.logForm['password'].valid && this.logForm['mode'].valid) {
      const loginData =  {
        username: this.logForm['login'].value,
        password: this.logForm['password'].value,
        mode: this.logForm['mode'].value,
      }
      // console.log(loginData);
      this.isLoading = true;

      this.authService.login(loginData).subscribe({
        next: ( response ) => {
          this.loginForm.reset();
          this.logForm['mode'].setValue('real');
          this.loginSubmit = false;

          this.isLoading = false;
          this.closeModal();
        },
        error: (err) => {
          this.loginForm.reset();
          this.logForm['mode'].setValue('real');
          this.isLoading = false;

          let toastrErrorMessage:string;
          if (err.error && err.error.message){
            // if there is a rival error message: = invalid username/password, account locked, API method error
            toastrErrorMessage = `${err.error.message}`
          } else if (err.message) {
            //other errors, like bad API url, no internet
            toastrErrorMessage = err.message

            //on GP brands invalid token is 401/jsonrpc_err,message = 'invalid credentials' //todo
            if(!this.configs.isRivalCasino){
              toastrErrorMessage = this.translate.instant('LOGIN.TOASTR_FAILED_MESSAGE')
            }
          } else {
            //fallback case for non-descriptive errors
            console.error(err)
            toastrErrorMessage = this.translate.instant('LOGIN.TOASTR_ERROR_LOGGEDOUT_TIP')
          }
          this.toastr.error(toastrErrorMessage, this.translate.instant('LOGIN.TOASTR_FAILED_H1'), {toastClass: 'ngx-toastr yourclass'})
        },
        complete: () => {
          //after successful next OR expired token error handled in interceptor by sending EMPTY
          this.isLoading = false;
        }
      })
    }
  }


  onRegModalOpened(): void {
    this.closeModal();
    this.modalService.open(this.hasMinReg ? 'minSignUpModal': 'signUpModal')
    //send event to GA
    this.gaService.event('register_page_loaded', undefined, undefined, undefined, undefined,{play_mode: "real", ...this.trackingService.getAffiliateOptions() });
  }

  closeModal(){
    this.modalService.close('signInModal')
  }

  onResetPwModalOpened(){
    this.closeModal();
    this.modalService.open('resetPwModal')
  }

  get logForm() {
    return this.loginForm.controls;
  }

  //Hide/show password
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

}
